<template>
    <base-section v-if="section" :section="section" :show-config-ui="showConfigUi" @edit-section="$emit('edit-section')"
                  @delete-section="$emit('delete-section')">
        <div>
            饼图栏目内容
        </div>
    </base-section>
</template>

<script>
    import BaseSection from './BaseSection'
    import sectionService from '../../service/section'

    export default {
        name: "PieSection",
        components:{BaseSection},
        props: {
            id: Number,
            showConfigUi: Boolean,
            refreshId: {
                type:Number,
                default: 0
            },
            pageId: Number,
            templateId: Number,
            timeInterval: String
        },
        data(){
            return {
                section: null
            }
        },
        watch:{
            id(){
                this.init()
            },
            templateId(){
              this.init()
            },
            pageId(){
                this.init()
            },
            refreshId(){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
            async init(){
                const response = await sectionService.getSection(this.id, {templateId: this.templateId})
                this.section = response.data
            }
        }
    }
</script>

<style scoped>

</style>
